import { createAction, props } from '@ngrx/store';
import { Tab } from '../../services/tab/tab.service';
import { NavigationExtras } from '@angular/router';

export const initTabs = createAction('[Tabs] Init Tabs');

export const saveTabsToCache = createAction('[Tabs] Save Tabs to Cache');

export const closeTab = createAction('[Tabs] Close Tab', props<{ tab: Tab<any> }>());

export const Logout = createAction('[Tabs] Logout');

export const openTabConfirmationDialog = createAction('[Tabs] Open Tab Confirmation Dialog', props<{ tab: Tab<any> }>());

export const closeAndNavigateToPreviousTab = createAction('[Tabs] Close Tab and Navigate to Previous Tab', props<{ tab: Tab<any> }>());

export const closeTabSuccess = createAction('[Tabs] Close Tab Success', props<{ tab: Tab<any> }>());

export const saveTabSnapshot = createAction('[Tabs] Save Tab Snapshot', props<{ tab: Tab<any> }>());

export const saveSnapshotToStore = createAction('[Tabs] Save Snapshot to Store', props<{ snapshot: { tabId: string; state: any } }>());

export const restoreTabSnapshot = createAction('[Tabs] Restore Tab Snapshot', props<{ tab: Tab<any> }>());

export const runInitializeOrActivatedAction = createAction('[Tabs] Run Initialize or Activated Action', props<{ tab: Tab<any> }>());

export const runInitializeOrActivatedActionSuccess = createAction('[Tabs] Run Initialize or Activated Action Success');

export const noSnapshotFound = createAction('[Tabs] No Snapshot Found to Restore');

export const addOrActivateTab = createAction('[Tabs] Add or Activate Tab', props<{ tab: Tab<any> }>());

export const setActiveTab = createAction('[Tabs] Set Active Tab', props<{ tab: Tab<any> }>());

export const updateTabs = createAction('[Tabs] Update Tabs', props<{ tabs: Tab<any>[] }>());

export const removeSnapshot = createAction('[Tabs] Remove Snapshot', props<{ tab: Tab<any> }>());

export const updateTabName = createAction('[Tabs] Update Tabbing Config', props<{ name: string }>());

export const navigateAssumeCurrentTab = createAction(
  '[Tabs] Navigate and Assume Current Tab',
  props<{ route: string; navigationExtras?: NavigationExtras }>()
);

export const navigate = createAction('[Tabs] Router Navigate', props<{ route: string[]; navigationExtras?: NavigationExtras }>());

export const noOp = createAction('[Tabs] No Operation');

export const runTabLoadOnNavigation = createAction('[Tabs] Run Tab Load on Navigation', props<{ tab?: Tab<any> }>());

export const tabBarNavigate = createAction('[Tabs] Tab Bar Navigate', props<{ tab: Tab<any> }>());

export const clearTabSnapshot = createAction('[Tabs] Clear Tab Snapshot');

export const initSyncStateToUrl = createAction('[Tabs] Init Sync State To URL', props<{ tab: Tab<any> }>());

export const initSyncStateToUrlSuccess = createAction(
  '[Tabs] Init Sync State To URL Success',
  props<{ activeTab: Tab<any>; fullRoute: string; navigationExtras: NavigationExtras }>()
);

export const destroySyncStateToUrl = createAction('[Tabs] Destroy Sync State To URL');

export const initSyncUrlToState = createAction('[Tabs] Init Sync URL To State', props<{ tab: Tab<any> }>());

export const initSyncUrlToStateSuccess = createAction(
  '[Tabs] Init Sync URL To State Success',
  props<{ queryParamStateKey: string; state: any }>()
);
